import { Group } from '@web/components/atoms/Layout'
import PageRadioButton from '../atoms/PageRadioButton'

type RadioPanelProps = {
  options: string[]
  selectedOption: string
  onChange: (option: string) => void
  isAttached?: boolean
  styles?: Record<string, string | undefined>
}

const RadioPanel = ({ options, selectedOption, styles, onChange, isAttached }: RadioPanelProps) => {
  return (
    <Group
      attached={isAttached}
      grow={true}
      w="100%"
      css={{
        '@container page (min-width: 0px)': {
          button: {
            fontSize: '16px',
          },
        },
        '@container page (min-width: 500px)': {
          button: {
            fontSize: '20px',
          },
        },
      }}
    >
      {options.map((value) => (
        <PageRadioButton
          key={value}
          isActive={selectedOption === value}
          onClick={() => onChange(value)}
          buttonText={value}
          styles={styles}
        />
      ))}
    </Group>
  )
}

export default RadioPanel
